import script from "./FormCadastroAtividade.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCadastroAtividade.vue?vue&type=script&setup=true&lang=js"

import "./FormCadastroAtividade.vue?vue&type=style&index=0&id=5d5793f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5793f8"]])

export default __exports__